<script lang="ts">
  import { onMount } from 'svelte';

  // Trust boundary: feedHtml comes from Notion CMS, synced to git at build time.
  // No runtime API calls to untrusted sources. If CMS is compromised, content
  // files must be re-synced. Consider adding DOMPurify if this trust model changes.
  let feedHtml: string = '';
  let loading: boolean = true;

  onMount(() => {
    fetch('/content/posts.html')
      .then(r => r.ok ? r.text() : Promise.reject())
      .then(html => { feedHtml = parseFeedHtml(html); loading = false; })
      .catch((e) => {
        (window as any).Logger?.log?.({
          ts: Date.now(), module: 'ScreenFeed', fn: 'loadContent',
          inputs: {}, output: null, durationMs: 0, error: e, level: 'warn'
        });
        feedHtml = '<p class="screen-placeholder">Content unavailable</p>';
        loading = false;
      });
  });

  function parseFeedHtml(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    const articles = div.querySelectorAll('article, .post, h2, h3');
    if (!articles.length) return html;
    let result = '';
    articles.forEach(el => {
      const title = el.querySelector('h1,h2,h3')?.textContent || el.textContent?.split('\n')[0] || 'Untitled';
      const body = (el.textContent || '').replace(title, '').trim().substring(0, 200);
      const linkUrl = el.querySelector('a')?.href || '#';
      result += `<div class="feed-card"><div class="feed-card-title">${title}</div><div class="feed-card-preview">${body}...</div><button class="feed-card-read" data-url="${linkUrl}">[Read]</button></div>`;
    });
    return result || html;
  }

  function handleFeedClick(e: MouseEvent) {
    const target = e.target as HTMLElement;
    if (target.classList.contains('feed-card-read')) {
      const url = target.dataset.url;
      if (url && url !== '#') window.open(url, '_blank');
    }
  }
</script>

{#if loading}
  <p class="screen-placeholder">Loading...</p>
{:else}
  <div on:click={handleFeedClick}>{@html feedHtml}</div>
{/if}
